import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';

// light-icon-button.component.ts
@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-light-icon-button',
  template: `
    <app-base-button
      [baseClass]="'bg-theme-surface-light text-theme-secondarybutton py-1 px-5 rounded-lg flex items-center justify-between border border-theme-secondarybutton-light'"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
      stateColorScheme="surface"
    >
      <div class="flex justify-center w-full">
        <div class="flex flex-row items-center">
          <i *ngIf="leftIcon" class="fas text-lg mr-2" [class]="leftIcon"></i>
          <div class="text-center text font-medium">{{ text }}</div>
          <i *ngIf="icon" class="fas text-lg ml-2" [class]="icon"></i>
        </div>
      </div>
    </app-base-button>
  `
})
export class LightIconButtonComponent {
  @Input() icon?: string;
  @Input() leftIcon?: string;
  @Input() text: string = 'Action';
  @Input() disabled: boolean = false;
  @Output() onClick = new EventEmitter<MouseEvent>();
}
